import React, { Component } from 'react';
import {Link} from "react-router-dom";

import PushHistory from '../../../utils/PushHistory';
import { getSystemSettings } from '../../../utils/SettingsRetriever';
import IntlMessage from '../../../LocaleEngine';
import LocaleAsString from '../../../LocaleEngine/LocaleAsString';

import Container from '@material-ui/core/Container';
import SpotlioIcon from '../../Icon';

export default class TabGenerator extends Component{
    constructor(props){
        super(props);
        this.state = {
            selectedTab: -1
        }
    }

    renderLink = (parameters) => {
        const system = getSystemSettings();
        const linkContent = (
            <React.Fragment>
                {parameters.icon}
                <span className="label">{parameters.title}</span>
            </React.Fragment>
        )
        if (system.categories[parameters.index].code === "link") {
            const category = system.categories[parameters.index];
            const link = category.href[0];
            const target = category.config.linkTarget || "_blank";

            return (
                <a key={parameters.index} title={parameters.linkTitle} className={parameters.class + ' headerTab'} href={link} target={target}>
                    {linkContent}
                </a>)
        }else{
            // render link
            return (
            <Link key={parameters.index} to={parameters.path} title={parameters.linkTitle} className={parameters.class + ' headerTab'}>
                {linkContent}
            </Link>)
        }
    }

    handlePush = (path, idx) => {
        const system = getSystemSettings();
        if (system.categories[idx].code === "link") {
            const category = system.categories[idx];
            window.open(category.href[0], category.config.linkTarget || "_blank");
        } else {
            PushHistory(path);
            this.setState({selectedTab:idx})
        }
    }

    handleActionMobile = (urlPath, idx) => {
        this.handlePush(urlPath, idx);
        this.props.toggleMenu()
    }

    // renderShoppingCartButton = () => {
    //     return (
    //         <button className="cartButton" onClick={() => this.props.openSideCart()}>
    //             <span className="label"><IntlMessage id="cart.general.title" /></span>
    //         </button>
    //     );
    // }

    render(){
        let items = [];
        let mobile = [];
        const system = getSystemSettings();
        const url = window.location.pathname;

        if (system.b2b && system.b2b.showB2CTabs === false) return '';

        // if (system.hasOwnProperty('categories')) {
        if(system.categories){
            system.categories.forEach((val, idx) => {
                let urlPath = val.href[0];
                if (val.href.indexOf(url) > -1 || (url === '/' && val.href.indexOf(system.app.defaultPage) >= 0)) {
                    if (this.state.selectedTab !== idx) {
                        this.setState({selectedTab:idx});
                    }
                }
                if (this.state.selectedTab === -1) {
                    val.href.forEach(jdx => {
                        if (url.substring(0, jdx.length) === jdx) {
                            if (this.state.selectedTab !== idx) {
                                this.setState({selectedTab:idx});
                            }
                        }
                    })
                }

                let icon = 'sp2-mountains';
                if(val.icon !== ''){
                    icon = val.icon;
                }

                let visible = true;
                if(val.hide){
                    visible = false;
                }

                if(this.props.upselling){
                    if(val.hide_upselling){
                        visible = false;
                    }
                }

                if(visible){
                    let code = val.code;
                    if(val.code === 'link') code = val.type;

                    let title = ""
                    if (val.title) title = LocaleAsString(val.title)
                    else title = <IntlMessage id={"skin.global.tabs." + code} />;

                    let iconElement = <SpotlioIcon icon={icon} />;
                    if(system.head.tabs){
                        if(system.head.tabs.icons && system.head.tabs.icons === 'hide'){
                            if(!this.props.upselling){
                                iconElement = '';
                            }
                        }
                    }

                    let classElement = 'large';
                    if(system.head.tabs){
                        if(system.head.tabs.mode){
                            classElement = system.head.tabs.mode;
                        }
                        if(system.head.tabs.extraClass){
                            classElement += ' ' + system.head.tabs.extraClass;
                        }
                    }
                    items.push(
                        this.renderLink({
                            index: idx,
                            path: urlPath,
                            linkTitle: LocaleAsString("skin.global.tabs." + val.code),
                            class: classElement + ((idx === this.state.selectedTab) || (window.location.pathname.match('packages') && val.code === "packages") ? " active" : ""),
                            icon: iconElement,
                            title: title
                        })
                        // <button key={idx} onClick={() => this.handlePush(urlPath, idx)} title={LocaleAsString("skin.global.tabs." + val.code)} className={classElement + ((idx === this.state.selectedTab) || (window.location.pathname.match('packages') && val.code === "packages") ? " active" : "")}>
                        //     {iconElement}
                        //     <span className="label">{title}</span>
                        // </button>
                    )
                    mobile.push(
                        <div key={idx} onClick={() => (this.handleActionMobile(urlPath, idx))} className={"option " + ((idx === this.state.selectedTab) || (window.location.pathname.match('packages') && val.code === "packages") ? " active" : "")}>
                            {iconElement}
                            <span className="categoryText">{title}</span>
                        </div>
                    )
                }
            })
        } else {
            this.forceUpdate();
        }

        return (
            <Container className="container" maxWidth="lg">
                {this.props.isMobile ?
                    mobile
                    :
                    items
                }
                {/* {!(this.props.upselling) ?
                <div className="CartButtonWrapper">
                    {
                        this.renderShoppingCartButton()
                    }
                </div>
                : null} */}
            </Container>
        )
    }
}


